import Outlet from "./types/Outlet";

const FORM_CONFIG = {
	validateMessages: {
		required: "This field is required."
	},
	layout: "vertical",
	validateTrigger: ["onBlur", "onSubmit"]
};

const DEFAULT_DATA: Outlet = {
	outletStatus: false,
	participatingInChangiEv: false,
	tenantCode: "",
	tenantName: "",
	outletCode: "",
	outletName: "",
	vendorCode: "",
	rentalSerialNo: "",
	effectiveDate: undefined,
	expiryDate: undefined,
	terminal: undefined,
	unitNo: "",
	airLand: undefined,
	location: "",
	concession: "",
	trade: "",
	businessCategory: "",
	productCategory: "",
	floorName: "",
	categoryType1: "",
	categoryType2: "",
	categoryType3: undefined,
	categoryType4: "",
	categoryType5: "",
	tags: []
};

const TERMINAL_OPTIONS = [
	{ label: "TO", value: "T0" },
	{ label: "T1", value: "T1" },
	{ label: "T2", value: "T2" },
	{ label: "T3", value: "T3" },
	{ label: "T4", value: "T4" },
	{ label: "TJ", value: "TJ" }
];

const AIR_LAND_OPTIONS = [
	{ label: "A", value: "A" },
	{ label: "L", value: "L" },
	{ label: "U", value: "U" }
];

const FIELD_CONFIG: { [key: string]: { label: string; required: boolean } } = {
	outletStatus: { label: "Is outlet active?", required: false },
	participatingInChangiEv: { label: "Participating in Changi eV", required: false },
	storeId: { label: "Store ID", required: false },
	smStoreId: { label: "SM Store ID", required: false },
	tenantCode: { label: "Tenant Code", required: true },
	tenantName: { label: "Tenant Name", required: true },
	outletCode: { label: "Outlet Code", required: true },
	outletName: { label: "Outlet Name", required: true },
	vendorCode: { label: "Vendor Code", required: false },
	rentalSerialNo: { label: "Rental Serial No.", required: false },
	effectiveDate: { label: "Effective Date", required: false },
	expiryDate: { label: "Expiry Date", required: false },
	terminal: { label: "Terminal", required: false },
	unitNo: { label: "Unit No.", required: false },
	location: { label: "Location", required: false },
	airLand: { label: "Air/ Land", required: false },
	concession: { label: "Concession", required: true },
	trade: { label: "Trade", required: false },
	businessCategory: { label: "Business Category", required: false },
	productCategory: { label: "Product Category", required: false },
	floorName: { label: "Floor Name", required: false },
	categoryType1: { label: "Category Type 1 (Terminal)", required: false },
	categoryType2: { label: "Category Type 2 (L/A)", required: false },
	categoryType3: { label: "Category Type 3", required: false },
	categoryType4: { label: "Category Type 4", required: false },
	categoryType5: { label: "Category Type 5", required: false },
	tags: { label: "Tags", required: false }
};

const DATE_FORMAT = "YYYY-MM-DD";

export { FIELD_CONFIG, FORM_CONFIG, DEFAULT_DATA, TERMINAL_OPTIONS, AIR_LAND_OPTIONS, DATE_FORMAT };
